import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

// Auto-inject Authorization header
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Seules les lectures se rejouent. Une écriture rejouée après un 5xx crée un
// doublon : la requête a pu aboutir côté serveur avant que la réponse échoue.
const RETRYABLE_METHODS = ['get', 'head', 'options'];

export function isRetryable(error) {
  const config = error?.config;
  if (!config || config._retried) return false;
  if (!RETRYABLE_METHODS.includes((config.method || 'get').toLowerCase())) return false;
  return !error.response || error.response.status >= 500;
}

// Retry once on network error or 5xx, user-friendly error messages
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;

    if (isRetryable(error)) {
      config._retried = true;
      await new Promise((r) => setTimeout(r, 1000));
      return api(config);
    }

    // User-friendly error handling
    const status = error.response?.status;

    if (status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
      return Promise.reject(error);
    }

    if (status === 403) {
      error.userMessage = "Vous n'avez pas les permissions nécessaires.";
    } else if (status === 429) {
      error.userMessage = 'Trop de requêtes. Veuillez patienter avant de réessayer.';
    } else if (status >= 500) {
      error.userMessage = 'Erreur serveur. Veuillez réessayer plus tard.';
    } else if (!error.response) {
      error.userMessage = 'Erreur réseau. Vérifiez votre connexion internet.';
    }

    return Promise.reject(error);
  }
);

export default api;
